export { default } from './IndustryCard';
